module.exports = __webpack_public_path__ + "static/media/VV 3 upd.f3bda785.mp3";